import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      <i>El libro de la selva</i> es una de las historias más recordadas de la literatura infantil y fue Walt Disney, ya
      no Kipling, quien la grabó en la memoria de muchos gracias a la película homónima estrenada en 1967. “Busca lo más
      vital no más”, cantaba el oso Balú mientras el pequeño Mowgli bailaba y Baguira se quejaba.
    </p>
    <p className="content justified">
      Pero <i>El libro de la jungla</i> fue publicado originalmente en 1894 como una serie de cuentos en las que el
      protagonista es Mowgli, un niño-lobo que es adoptado por la selva.
    </p>
    <p className="content justified">
      Uno de esos grandiosos cuentos, uno de esos que omitió Disney en su película, fue fielmente adaptado al
      radioteatro por Oswaldo Díaz Díaz en 1955 para la serie <i>Leyendas</i>. En este, Mowgli y Kaa, la sabia serpiente
      pitón, se han hecho amigos. Kaa, en una de sus cacerías, encontró algunos objetos custodiados por una cobra
      blanca.
    </p>
    <p className="content justified">
      “¿Es buena caza?”, pregunta Mowgli inquieto. No, no es nada vivo, es otra cosa. Mowgli, que ha crecido entre lobos
      y valora la caza sobre las riquezas, llena de preguntas a Kaa mientras van a las ruinas y se internan bajo la
      tierra.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      Allí descubren una cueva llena de tesoros, piedras preciosas, oro, más oro, y una pitón poderosa y amargada que no
      se ha enterado de que la ciudad que se levantaba sobre el botín ha desaparecido hace mucho tiempo. “Llévate algo”,
      le dice la pitón, y Mowgli, después de la insistencia, cae en la trampa.
    </p>
    <p className="content justified">
      No diremos lo que ocurre acá, pues dañaríamos la historia, sin embargo hay que decir que al final la narración se
      centra en un objeto, un objeto metálico que, sin ser mágico, lleva consigo la muerte. No es magia, es la avaricia
      del hombre que hace que todo lo que toque termine untado de sangre, como dice el niño-lobo.
    </p>
    <p className="content justified">
      Muy acertada la selección de este título. Muy bien adecuada al radioteatro. Es tan fiel a la obra de Kipling, que
      escuchar este cuento es casi como leer el cuento. No omite los detalles relevantes, ajusta las descripciones a las
      voces de los personajes de manera que suenan muy naturales y, al final, conserva la reflexión que de fondo
      conlleva el cuento de Kipling.
    </p>
    <p className="content justified">
      Se lamenta un poco la voz de Mowgli, a quien llaman “hombrecito” pero suena como un “mancancán”. Además de esto,
      no hay de qué quejarse. Don Os una vez más mostró su buen ojo para los relatos y el buen tino para llevarlos al
      alcance de cualquier oído.
    </p>
  </div>
);

export const sections = <div className="sectionsReview"></div>;
